import AxiosInstance from "../instance";
import {emptyFn, returnValidResponse} from "../utils";


const startVideoToTextJob = async (url: string, languageCode: string) => {
    const response = await AxiosInstance.getInstance().post("/video-to-text", {
        language_code: languageCode,
        url
    });

    return response;
};

const getVideoToTextLanguages = async () => {
    const response = await AxiosInstance.getInstance().get("/video-to-text/languages").catch(emptyFn);
    return returnValidResponse(response);
};

const getVideoToTextJobResult = async (jobId: string) => {
    const response = await AxiosInstance.getInstance().get("/video-to-text", {
        params: {
            id: jobId
        }
    }).catch(emptyFn);

    return response;
};

export {startVideoToTextJob, getVideoToTextJobResult, getVideoToTextLanguages};


// WEBPACK FOOTER //
// ./src/api/models/VideoToText.ts